// constants/apiConstants.js

import { DECLARATION } from "stylis";

export const API_BASE_URL =process.env.REACT_APP_API_BASE_URL;
// https://property-api.crescenthomes.ca/admin/login
// "https://property-api.crescenthomes.ca/" || 
// export const API_BASE_URL_1 = "https://api-stage.spinsagacasino.com:5000";
export const API_FAIL_MESSAGE = "Something went wrong";
export const SUCCESS = "success";
export const BASE_IMAGE_URL = "https://cdn.spinsagacasino.com:5000/";
// All API endpoints in one place

export const API_ENDPOINTS = {
  // Auth
  LOGIN: "/admin/login",

  //only pdf endpoint
  UPLOAD_PDF:"/api/property/uploadPdf",

  // Communities
  GET_COMMUNITIES: "/api/property/communities",
  CREATE_COMMUNITY: "/api/property/createCommunity",
  UPDATE_COMMUNITY: "/api/property/updateCommunity",
  GET_ALL_DOC_TYPES:'/api/property/documentTypes',
  DELETE_COMMUNITY: "/api/property/deleteCommunity",
  DELETE_COMMUNITY_DOCUMENT: "/api/property/deleteCommunityDocument",
  // Features
  GET_FEATURES: "/api/property/features",
  CREATE_FEATURE: "/api/property/createfeatures",
  UPDATE_FEATURE: "/api/property/updatefeatures",

  // Amenities
  GET_AMINITIES: "/api/property/aminities",
  CREATE_AMENITY: "/api/property/createAmenities",
  UPDATE_AMENITY: "/api/property/updateAmenities",

  // Build Styles
  GET_BUILDSTYLES: "/api/property/buildstyles",
  CREATE_BUILDSTYLE: "/api/property/buildstyle",
  UPDATE_BUILDSTYLE: "/api/property/updatebuildstyle",

  // Properties
  GET_PROPERTIES: "/api/property/properties",
  IMAGE_UPLOAD:  "api/property/upload/bannerimage", //   "/upload/bannerimage",
  CREATE_PROPERTY: "/api/property/createProperty",
  UPDATE_PROPRTY: "/api/property/updateProperty",
  GET_STATES: "/api/property/states",
  GET_CITY: "/api/property/city",
  DELETE_PROPERTY: "/api/property/deleteProperty/",

  // Broker
  GET_BROKERS: "/broker/users/all",
  CREATE_BROKER: "/broker/users/fullsignup",
  UPDATE_BROKER: "/broker/broker/update",
  DELETE_BROKER: "/broker/deleteBroker/",

  //Enquiry
  GET_ENQUIRIES: "/api/booking/getEnquiry",

  //Bookings
  GET_BOOKINGS: "/api/booking/getBookings",
  APPROVE_BOOKING: "/api/booking/approve",
  CANCEL_BOOKING: "/api/booking/cancel",

  //inventory
  GET_INVENTORY: "api/property/inventory",
  ADD_INVENTORY: "api/property/addInventory",

  //promotion
  GET_ALL_PROMOTIONS: "/api/promotion/promotions",
  CREATE_PROMOTION: "/api/promotion/create",
  UPDATE_PROMOTION: "/api/promotion/update",
  DELETE_PROMOTION: "/api/promotion/delete",

};
